// extracted by mini-css-extract-plugin
module.exports = {"root":"MillionsIcon_root__kCqUU","tipHand":"MillionsIcon_tipHand__gtf0U"};